import { User } from '../../../interfaces/backend/User';
import { CodeSample, UserObject } from './CodeSample';

export interface UserObjectProperty {
  value: string;
  comment?: string;
}

export type UserObjectStringMap = Record<
  keyof UserObject,
  string | UserObjectProperty
>;

export abstract class BackendCodeSample extends CodeSample {
  abstract buildUserObject(user: User): UserObjectStringMap;

  protected buildUserObjectString(user: User, joinChar: string): string {
    const userObject = this.buildUserObject(user);

    // Order properties
    const userProperties = [
      userObject['id'],
      userObject['email'],
      userObject['number']
    ];

    return userProperties
      .map((property, i) => {
        const value = typeof property === 'object' ? property.value : property;
        const comment =
          typeof property === 'object' && property.comment
            ? ` ${this.commentChar} ${property.comment}`
            : '';
        const comma = i < userProperties.length - 1 ? ',' : '';

        return `${value}${comma}${comment}`;
      })
      .join(joinChar);
  }
}
